import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import { RESPONSIVE_GRID } from '../../constants/cmsResourceTypes';
import CmsComponentGrid from '../../components/CmsComponentGrid';
import styles from './index.module.scss';
const ResponsiveGrid = ({ childComponents, deviceBreakpoints, position, preloadImages = false, }) => (_jsx("div", { className: classNames(styles.grid), children: _jsx(CmsComponentGrid, { childComponents: childComponents, deviceBreakpoints: deviceBreakpoints, position: position, preloadImages: preloadImages }) }));
ResponsiveGrid.resourceType = RESPONSIVE_GRID;
export default ResponsiveGrid;
//# sourceMappingURL=index.js.map